import { Rotulo3D } from '../componentes/Rotulo3D'
import { RAIO_CORDA_M, SegmentoCorda } from './Cordas3D'
import { GRAVIDADE_M_S2, type VetorTabletop } from '../../dominio/tabletop'

/** O quadro da simulação do V que a cena mostra: as fixações e onde a massa está agora. */
export interface QuadroParaCena {
  readonly fixacoes: readonly [VetorTabletop, VetorTabletop]
  readonly quadro: {
    readonly t: number
    readonly centro: VetorTabletop
    readonly tensoesN: readonly [number, number]
  }
}

export const COR_SIMULACAO = '#22d3ee'

/**
 * A massa simulada e as duas pernas até ela, em ciano e um pouco transparentes,
 * para não se confundir com a ancoragem desenhada. Perna sem tensão (frouxa ou
 * que cedeu) aparece mais apagada.
 */
export function Simulacao3D({ fixacoes, quadro }: QuadroParaCena) {
  const { centro, tensoesN } = quadro
  return (
    <group name="simulacao-ancoragem">
      {fixacoes.map((fixacao, i) => (
        <SegmentoCorda
          key={i}
          de={fixacao}
          para={centro}
          cor={COR_SIMULACAO}
          raio={RAIO_CORDA_M * 1.2}
          opacidade={tensoesN[i]! > 1 ? 0.85 : 0.25}
        />
      ))}
      <mesh raycast={() => null} position={[centro[0], centro[1], centro[2]]}>
        <sphereGeometry args={[0.13, 20, 14]} />
        <meshStandardMaterial color={COR_SIMULACAO} transparent opacity={0.85} roughness={0.4} />
      </mesh>
      <Rotulo3D
        posicao={[centro[0], centro[1] - 0.25, centro[2]]}
        texto={`simulação · ${Math.round(tensoesN[0] / GRAVIDADE_M_S2)} / ${Math.round(tensoesN[1] / GRAVIDADE_M_S2)} kgf`}
        subtexto={`${quadro.t.toFixed(1).replace('.', ',')} s`}
        sempreVisivel
        fator={5}
      />
    </group>
  )
}
